module.exports = __webpack_public_path__ + "static/media/16_tn.31a14d05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/16_tn.jpg
// module id = 325
// module chunks = 0